<i class="far fa-comments" data-fa-symbol="comments"></i>

<div class="wrapper">
  <div class="table-container">
    <div class="today-content">
      <qm-clock *qmAuth="'clock'" mode="digital"></qm-clock>
      <div class="today-card alarm-list" *qmAuth="'today-alarm-list'">
        <div class="today-card-header">
          <span>{{'Alarmlist' | translate}}</span>
        </div>
        <div class="today-card-body">
          <qm-alarm-diagram></qm-alarm-diagram>
        </div>
      </div>
      <qm-vrgroup-train-fidelity-db *qmAuth="'train-fidelity'" style="margin-bottom:0.25em"></qm-vrgroup-train-fidelity-db>
      <div *qmAuth="'cause-dashboard'" class="today-card">
        <div class="today-card-header">
          {{'Top 10 causes of delay' | translate}}
        </div>
        <div class="today-card-body">
          <qm-vrgroup-cause-dashboard></qm-vrgroup-cause-dashboard>
        </div>
      </div>
      <div *qmAuth="'weather'" class="today-card">
        <div class="today-card-header">
          <a href="https://www.foreca.fi/Finland/Helsinki/10vrk" target="_blank" rel="noopener noreferrer">
            {{'Weather' | translate}}
          </a>
        </div>
        <div class="today-card-body">
          <qm-weather></qm-weather>
        </div>
      </div>
      <div *qmAuth="'vivo'" class="today-card">
        <div class="today-card-header">
          <a href="https://miprovivo.trackinno.com" target="_blank" rel="noopener noreferrer">
            Mipro VIVO
          </a>
        </div>
        <div class="today-card-body">
        </div>
      </div>
      <div *qmAuth="'today-notifications'" class="today-card">
        <div class="today-card-header">
          <a (click)="toggleSidebarPanel('Notification')">
            {{'Whiteboard' | translate}}
          </a>
        </div>
        <div class="today-card-body whiteboard">
          <div class="">
            <a (click)="toggleSidebarPanel('Notification')">{{'New notifications on this week' | translate}}:
              {{notificationCount}}</a>
          </div>
        </div>
      </div>
      <div *qmAuth="'vivo'" class="today-card">
        <div class="today-card-header">
          <a (click)="toggleSidebarPanel('Diary')">
            {{'Diary' | translate}}
          </a>
        </div>
        <div class="today-card-body whiteboard">
          <div class="">
            <a (click)="toggleSidebarPanel('Diary')">{{'This week´s' | translate}}:
              {{diaryEvents}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
